import React from 'react';
import logoPrimary from '../assets/logo-primary.png';
import logoWhite from '../assets/logo-white.png';

// ── ICON ─────────────────────────────────────────────────────────────────────
const iconPaths = {
  recycle: "M12 4V2M12 2L9 5M12 2L15 5M4 12H2M2 12L5 15M2 12L5 9M20 12H22M22 12L19 9M22 12L19 15M12 20V22M12 22L15 19M12 22L9 19",
  tool: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
  briefcase: "M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2zM16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2",
  cpu: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 0 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 0-2-2V9m0 0h18",
  home: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM9 22V12h6v10",
  users: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75M9 7a4 4 0 1 0 0 8 4 4 0 0 0 0-8z",
  book: "M4 19.5A2.5 2.5 0 0 1 6.5 17H20M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z",
  settings: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z",
  logout: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  plus: "M12 5v14M5 12h14",
  edit: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
  trash: "M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
  external: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3",
  check: "M20 6L9 17l-5-5",
  x: "M18 6L6 18M6 6l12 12",
  mail: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6",
  send: "M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z",
  inbox: "M22 12h-6l-2 3h-4l-2-3H2M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
  search: "M21 21l-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0z",
  lock: "M19 11H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2zM7 11V7a5 5 0 0 1 10 0v4",
  award: "M12 15a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM8.21 13.89L7 23l5-3 5 3-1.21-9.12",
  chart: "M18 20V10M12 20V4M6 20v-6",
  chevronDown: "M6 9l6 6 6-6",
  chevronRight: "M9 18l6-6-6-6",
  alert: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01",
  eye: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
  reply: "M9 17H5a2 2 0 0 0-2 2v3M21 3H3l7 9.46V19l4 2v-8.54L21 3z",
  filter: "M22 3H2l8 9.46V19l4 2v-8.54L22 3z",
};

export function Icon({ name, size = 20, color = 'currentColor', className = '' }) {
  const path = iconPaths[name];
  if (!path) return null;
  return (
    <svg
      width={size} height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {path.split('M').filter(Boolean).map((p, i) => (
        <path key={i} d={'M' + p} />
      ))}
    </svg>
  );
}

// ── LOGO ──────────────────────────────────────────────────────────────────────
export function Logo({ size = 'md', variant = 'color' }) {
  const height = size === 'sm' ? 24 : size === 'lg' ? 36 : 28;
  const src = variant === 'white' ? logoWhite : logoPrimary;
  return (
    <img src={src} alt="AlgoAtWork" style={{ height, width: 'auto', display: 'block' }} />
  );
}

// ── BADGE ─────────────────────────────────────────────────────────────────────
export function Badge({ children, bg = 'var(--dark-05)', color = 'var(--dark-60)', dot }) {
  return (
    <span style={{ background: bg, color, fontSize: 11, fontWeight: 700, padding: '3px 9px', borderRadius: 999, letterSpacing: '0.05em', textTransform: 'uppercase', fontFamily: 'var(--font-heading)', display: 'inline-flex', alignItems: 'center', gap: 4, whiteSpace: 'nowrap' }}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: '50%', background: color, flexShrink: 0 }} />}
      {children}
    </span>
  );
}

// ── BUTTON ────────────────────────────────────────────────────────────────────
export function Button({ children, onClick, variant = 'primary', size = 'md', disabled = false, fullWidth = false, style: extra = {}, type = 'button' }) {
  const sizes = {
    sm: { padding: '6px 13px', fontSize: 12 },
    md: { padding: '10px 20px', fontSize: 14 },
    lg: { padding: '13px 26px', fontSize: 15 },
  };
  const variants = {
    primary: { background: 'var(--orange)', color: 'white', border: 'none' },
    secondary: { background: 'var(--dark-05)', color: 'var(--dark)', border: 'none' },
    ghost: { background: 'transparent', color: 'var(--dark-60)', border: '1.5px solid var(--dark-20)' },
    danger: { background: 'var(--danger-soft)', color: 'var(--danger)', border: 'none' },
    success: { background: 'var(--success-soft)', color: 'var(--success)', border: 'none' },
  };
  return (
    <button
      type={type}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{ fontFamily: 'var(--font-heading)', fontWeight: 600, borderRadius: 'var(--radius-md)', cursor: disabled ? 'not-allowed' : 'pointer', display: 'inline-flex', alignItems: 'center', gap: 7, transition: 'all 0.15s', opacity: disabled ? 0.5 : 1, width: fullWidth ? '100%' : 'auto', justifyContent: fullWidth ? 'center' : 'flex-start', ...sizes[size], ...variants[variant], ...extra }}
    >
      {children}
    </button>
  );
}

// ── INPUT ─────────────────────────────────────────────────────────────────────
export function Input({ label, value, onChange, type = 'text', placeholder = '', error, required }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && <label style={{ display: 'block', fontFamily: 'var(--font-heading)', fontSize: 13, fontWeight: 600, color: 'var(--dark-80)', marginBottom: 6 }}>{label}{required && <span style={{ color: 'var(--danger)', marginLeft: 3 }}>*</span>}</label>}
      <input
        type={type}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        style={{ width: '100%', padding: '10px 13px', border: `1.5px solid ${error ? 'var(--danger)' : 'var(--dark-20)'}`, borderRadius: 'var(--radius-md)', fontSize: 14, color: 'var(--dark)', outline: 'none', transition: 'border-color 0.15s', background: 'white' }}
        onFocus={e => { e.target.style.borderColor = 'var(--orange)'; }}
        onBlur={e => { e.target.style.borderColor = error ? 'var(--danger)' : 'var(--dark-20)'; }}
      />
      {error && <p style={{ color: 'var(--danger)', fontSize: 12, marginTop: 4 }}>{error}</p>}
    </div>
  );
}

// ── TEXTAREA ──────────────────────────────────────────────────────────────────
export function Textarea({ label, value, onChange, placeholder = '', rows = 5, required }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && <label style={{ display: 'block', fontFamily: 'var(--font-heading)', fontSize: 13, fontWeight: 600, color: 'var(--dark-80)', marginBottom: 6 }}>{label}{required && <span style={{ color: 'var(--danger)', marginLeft: 3 }}>*</span>}</label>}
      <textarea
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        style={{ width: '100%', padding: '10px 13px', border: '1.5px solid var(--dark-20)', borderRadius: 'var(--radius-md)', fontSize: 14, color: 'var(--dark)', outline: 'none', resize: 'vertical', lineHeight: 1.6, background: 'white', transition: 'border-color 0.15s' }}
        onFocus={e => { e.target.style.borderColor = 'var(--orange)'; }}
        onBlur={e => { e.target.style.borderColor = 'var(--dark-20)'; }}
      />
    </div>
  );
}

// ── SELECT ────────────────────────────────────────────────────────────────────
export function Select({ label, value, onChange, options, required }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && <label style={{ display: 'block', fontFamily: 'var(--font-heading)', fontSize: 13, fontWeight: 600, color: 'var(--dark-80)', marginBottom: 6 }}>{label}{required && <span style={{ color: 'var(--danger)', marginLeft: 3 }}>*</span>}</label>}
      <select
        value={value}
        onChange={e => onChange(e.target.value)}
        style={{ width: '100%', padding: '10px 13px', border: '1.5px solid var(--dark-20)', borderRadius: 'var(--radius-md)', fontSize: 14, color: 'var(--dark)', outline: 'none', background: 'white', appearance: 'none', cursor: 'pointer' }}
      >
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </select>
    </div>
  );
}

// ── MODAL ─────────────────────────────────────────────────────────────────────
export function Modal({ title, onClose, children, width = 560 }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(45,48,53,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 24 }} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div style={{ background: 'var(--white)', borderRadius: 'var(--radius-xl)', width: '100%', maxWidth: width, maxHeight: '90vh', overflowY: 'auto', boxShadow: 'var(--shadow-lg)', animation: 'fadeSlideIn 0.2s ease' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '22px 26px 18px', borderBottom: '1px solid var(--dark-10)' }}>
          <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: 18, fontWeight: 700, color: 'var(--dark)', margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ background: 'var(--dark-05)', border: 'none', width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--dark-60)' }}>
            <Icon name="x" size={16} />
          </button>
        </div>
        <div style={{ padding: 26 }}>{children}</div>
      </div>
    </div>
  );
}

// ── AVATAR ────────────────────────────────────────────────────────────────────
export function Avatar({ name, size = 36, bg = 'var(--dark)' }) {
  const initials = name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
  return (
    <div style={{ width: size, height: size, borderRadius: '50%', background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontFamily: 'var(--font-heading)', fontSize: size * 0.35, fontWeight: 700, flexShrink: 0 }}>
      {initials}
    </div>
  );
}

// ── EMPTY STATE ───────────────────────────────────────────────────────────────
export function EmptyState({ icon, title, message, action }) {
  return (
    <div style={{ textAlign: 'center', padding: '60px 24px', background: 'var(--dark-05)', borderRadius: 'var(--radius-xl)' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
        <Icon name={icon} size={40} color="var(--dark-20)" />
      </div>
      <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: 17, fontWeight: 700, color: 'var(--dark-60)', margin: '0 0 6px' }}>{title}</h3>
      <p style={{ fontSize: 14, color: 'var(--dark-40)', margin: '0 0 20px' }}>{message}</p>
      {action}
    </div>
  );
}
